export default __webpack_public_path__ + "images/watermark-logo-footer-white.d09ca4faa50fca12b25056569dd9b9f2.png";